import React from 'react';
import { Bot } from 'lucide-react';

interface IconoBotRazaProps {
    /** Lado del icono en px. */
    size?: number;
    /** Grosor del trazo. 2 es el del resto de la navegación, de ahí el valor
     *  por defecto; el Sidebar lo pasa explícito para que el bot no se vea más
     *  fino que los iconos que tiene al lado. */
    strokeWidth?: number;
    className?: string;
}

/**
 * Carita estática del bot de Raza.
 *
 * Es el `fallback` del Lottie `ai-chat-bot.json` (AIChatPanel) y el icono fijo
 * del botón «Ask Raza». Dos requisitos que vienen de cómo se usa:
 *
 *  1. **Hereda `currentColor`.** AskRazaButton lo pinta sobre `bg-navy-850` y
 *     sobre fondo claro con la misma etiqueta; un color fijo sería una mancha
 *     invisible en una de las dos. Por eso no lleva relleno propio.
 *  2. **Sin disco amarillo.** El robot del Lottie perdió el suyo porque lo pone
 *     el botón flotante que lo envuelve — repetirlo aquí lo duplicaría.
 *
 * Se apoya en `Bot` de lucide para no meter una segunda familia de iconos en la
 * app (misma regla que sigue el Sidebar).
 */
export const IconoBotRaza: React.FC<IconoBotRazaProps> = ({ size = 16, strokeWidth = 2, className = '' }) => (
    <Bot size={size} strokeWidth={strokeWidth} className={className} aria-hidden="true" />
);

export default IconoBotRaza;
